import React, { createContext, useContext, useState } from 'react';

export interface OrgSettings {
  teamType: string;
  roiHoursPerPoint: number;
  privacyDeleteRaw: boolean;
  privacyRedactPii: boolean;
  dataRetentionDays: number;
}

const DEFAULT_SETTINGS: OrgSettings = {
  teamType: 'Engineering',
  roiHoursPerPoint: 0.5,
  privacyDeleteRaw: false,
  privacyRedactPii: false,
  dataRetentionDays: 90,
};

interface OrgSettingsContextValue {
  settings: OrgSettings;
  updateSettings: (patch: Partial<OrgSettings>) => void;
}

const OrgSettingsContext = createContext<OrgSettingsContextValue>({
  settings: DEFAULT_SETTINGS,
  updateSettings: () => undefined,
});

export const OrgSettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [settings, setSettings] = useState<OrgSettings>(DEFAULT_SETTINGS);

  const updateSettings = (patch: Partial<OrgSettings>) => {
    setSettings((prev) => ({ ...prev, ...patch }));
  };

  return (
    <OrgSettingsContext.Provider value={{ settings, updateSettings }}>
      {children}
    </OrgSettingsContext.Provider>
  );
};

export const useOrgSettings = () => useContext(OrgSettingsContext);
